import getAnyOrNull from 'utils/accessors/getAnyOrNull.util';
import getArray from 'utils/accessors/getArray.util';
import nullBind from 'utils/functions/nullBind.util';

// These are the most simple getters,
// they will navigate the path, return the data found
// or default to null for null/undefined

export const selectCurrentSalon = ($) => $?.currentSalon ?? {};
export const selectCurrentSalonId = ($) => $?.currentSalon?.id ?? null;
export const selectCurrentSalonName = ($) => $?.currentSalon?.name ?? null;
export const selectCurrentSalonVatNumber = ($) => $?.currentSalon?.vat_number ?? null;

export const selectCurrentSalonWebsiteCustomer = ($) => $?.currentSalon?.is_slick_website_customer ?? null;

export const selectCurrentSalonAddress1 = ($) => $?.currentSalon?.address_line_1 ?? null;
export const selectCurrentSalonCity = ($) => $?.currentSalon?.city ?? null;
export const selectCurrentSalonClients = ($) => $?.currentSalon?.clientList ?? null;
export const selectCurrentSalonClientsArray = ($) => $?.currentSalon?.clientList ?? [];
export const selectCurrentSalonPhone = ($) => $?.currentSalon?.phone ?? null;
export const selectCurrentSalonStylists = ($) => $?.currentSalon?.stylistList ?? null;
export const selectCurrentSalonTimeZone = ($) => $?.currentSalon?.timezone ?? null;
export const selectCurrentSalonCountryCode = ($) => $?.currentSalon?.country?.code ?? null;
export const selectCurrentSalonLogo = ($) => $?.currentSalon?.profile_image ?? null;

export const selectCurrentSalonEssentialSplitPayments = ($) => $?.currentSalon?.essential_split_payments ?? null;
export const selectCurrentSalonSignUpMethod = ($) => $?.currentSalon?.sign_up_method ?? null;

export const selectCurrentSalonLists = ($) => $?.currentSalon?.lists ?? {};
export const selectCurrentSalonListsClients = ($) => $?.currentSalon?.lists?.clients ?? null;
export const selectCurrentSalonListsServices = ($) => $?.currentSalon?.lists?.services ?? null;
export const selectCurrentSalonListsStylists = ($) => $?.currentSalon?.lists?.stylists ?? null;
export const selectCurrentSalonAutoTopUpSms = ($) => $?.currentSalon?.auto_top_up_sms ?? null;

export const selectCurrentSalonNcobCustomAmount = ($) => $?.currentSalon?.ncob_custom_amount ?? null;
export const selectCurrentSalonNcobDeposiSettings = ($) => $?.currentSalon?.ncob_deposit_settings ?? null;

export const selectCurrentSalonServices = ($) => $?.currentSalon?.services ?? [];
export const selectCurrentSalonPricingPlan = nullBind(getArray, 'currentSalon.pricing_plan');
export const selectCurrentSalonPricingPlanId = nullBind(getArray, 'currentSalon.pricing_plan_id');
export const selectCurrentSalonNewPricing = nullBind(getAnyOrNull, 'currentSalon.new_pricing');
export const selectCurrentSalonOnlineBooking = nullBind(getAnyOrNull, 'currentSalon.online_booking');
export const selectCurrentSalonPostcode = nullBind(getAnyOrNull, 'currentSalon.postcode');
export const selectCurrentSalonSendSms = nullBind(getAnyOrNull, 'currentSalon.send_sms');
export const selectCurrentSalonCalendarMode = nullBind(getAnyOrNull, 'currentSalon.calendar_mode');
export const selectCurrentSalonCurrency = nullBind(getAnyOrNull, 'currentSalon.currency');
export const selectCurrentSalonCurrencySign = nullBind(getAnyOrNull, 'currentSalon.currency_symbol');
export const checkHideCashupForReceptionist = nullBind(getAnyOrNull, 'currentSalon.hide_cashup_for_receptionist');
export const checkHideDetailsForReceptionist = nullBind(
  getAnyOrNull,
  'currentSalon.hide_client_details_for_receptionist',
);
export const selectCurrentSalonHideDeletedStylistColumn = ($) => $?.currentSalon?.hide_deleted_stylist_column ?? null;
export const checkHideStockForReceptionist = nullBind(getAnyOrNull, 'currentSalon.hide_stock_for_receptionist');
export const selectCurrentSalonFlags = ($) => $?.currentSalon?.enabled_features ?? null;
export const selectCurrentSalonPosFlow = ($) => $?.currentSalon?.can_take_pos_payment ?? null;
export const selectCurrentSalonBilling = ($) => $?.currentSalon?.has_billing ?? null;
export const selectCurrentSalonRestrictedToCriticalServices = ($) =>
  $?.currentSalon?.is_restricted_to_critical_services ?? null;

export const selectCurrentSalonStripeAccount = nullBind(getAnyOrNull, 'currentSalon.has_ncob_stripe_account');
export const selectCurrentSalonNoShowProtection = nullBind(getAnyOrNull, 'currentSalon.no_show_protection');

export const selectCurrentSalonStripeStatus = nullBind(getAnyOrNull, 'currentSalon.stripe_account_status');
export const selectCurrentSalonReaderStatus = nullBind(getAnyOrNull, 'currentSalon.reader_status');
export const selectCurrentSalonEnabledPinAccess = ($) => $?.currentSalon?.enabled_pin_access ?? null;
export const selectCurrentSalonIsBarkers = nullBind(getAnyOrNull, 'currentSalon.is_barkers_salon');
export const selectCurrentSalonIsLoreal = nullBind(getAnyOrNull, 'currentSalon.is_loreal_salon');
export const selectCurrentSalonDigitalCardAddOn = nullBind(getAnyOrNull, 'currentSalon.digital_card_add_on');
export const selectCurrentSalonConfirmationSms = nullBind(getAnyOrNull, 'currentSalon.send_confirmation_sms');
export const selectCurrentSalonSmsTiming = nullBind(getAnyOrNull, 'currentSalon.sms_timing');
export const selectCurrentSalonSmsOffset = nullBind(getAnyOrNull, 'currentSalon.sms_offset');
export const selectCurrentSalonSmsCanceling = nullBind(getAnyOrNull, 'currentSalon.cancel_via_sms');
export const selectCurrentSalonConsultationLink = nullBind(getAnyOrNull, 'currentSalon.consultation_link');
export const selectCurrentSalonTinyUrl = nullBind(getAnyOrNull, 'currentSalon.ncob_tiny_url');
export const selectCurrentSalonGroupUrl = nullBind(getAnyOrNull, 'currentSalon.group_ncob_tiny_url');
export const selectCurrentSalonOpeningHours = nullBind(getAnyOrNull, 'currentSalon.openingHours');
export const selectCurrentSalonAllowanceYear = nullBind(getAnyOrNull, 'currentSalon.allowance_year');
export const selectCurrentSalonAllowanceYearStart = nullBind(getAnyOrNull, 'currentSalon.allowance_year_starts_at');
export const selectCurrentSalonSmsTextPolicy = nullBind(
  getAnyOrNull,
  'currentSalon.sms_after_reminder_cancellation_policy_text',
);
export const selectCurrentSalonSmsTextConsultation = nullBind(
  getAnyOrNull,
  'currentSalon.sms_after_reminder_consultation_form_text',
);
export const selectCurrentSalonSmsTextCustom = nullBind(getAnyOrNull, 'currentSalon.sms_after_reminder_custom_text');
export const selectCurrentSalonSmsTextParking = nullBind(getAnyOrNull, 'currentSalon.sms_after_reminder_parking_text');
export const selectCurrentSalonSmsAfterReminder = nullBind(getAnyOrNull, 'currentSalon.enable_sms_after_reminder');
export const selectCurrentSalonSmsSelectTemplate = nullBind(
  getAnyOrNull,
  'currentSalon.selected_template_sms_after_reminder',
);
export const selectCurrentSalonHasSelfEmployedStripeAccount = nullBind(
  getAnyOrNull,
  'currentSalon.has_self_employed_stripe_account',
);
export const selectCurrentSalonBetaAnnualSalon = nullBind(getAnyOrNull, 'currentSalon.beta_annual_salon');
export const selectCurrentSalonTakeTipViaPos = nullBind(getAnyOrNull, 'currentSalon.take_tip_via_pos');
